export const getApiError = (error, fallbackMessage = "Something went wrong. Please try again!") => {
  const responseData = error.response?.data;

  return {
    status: error.response?.status,
    message:
      (typeof responseData === "string" && responseData) ||
      responseData?.message ||
      responseData?.Message ||
      responseData?.detail ||
      responseData?.error ||
      error.message ||
      fallbackMessage,
  };
};
